angular.module('admin')
.controller('AdminUsersController', ['$scope', '$state', '$uibModal', 'Notification', 'ModalHandler', 'Practice', 'ProviderInvitation', 'User', 'FREE_TRIAL_PERIOD', 'Logger', 'Role', 'Procedure', 'USER_ROLES', 'ConfirmDialog',
    function ($scope, $state, $uibModal, Notification, ModalHandler, Practice, ProviderInvitation, User, FREE_TRIAL_PERIOD, Logger, Role, Procedure, USER_ROLES, ConfirmDialog) {
        $scope.practiceTypes = Procedure.practiceTypes({'include_procedures': false});
        var notificationPreferencesOpened = false;

        $scope.initPractice = function () {
            $scope.practice = Practice.get({practiceId: $scope.$parent.auth.practice_id}, function (practice) {
                if ($state.is('admin.users.notifications') && !notificationPreferencesOpened) {
                    var currentUser = practice.users.find(function (user) {
                        return user.id === $scope.$parent.auth.id;
                    });
                    if (currentUser) {
                        notificationPreferencesOpened = true;
                        $scope.editDialog(currentUser, true);
                    }
                }
            });

            $scope.invitedUsers = [];
            User.getInvitees({user_id: $scope.$parent.auth.id, practice_id: $scope.$parent.auth.practice_id }, function(allInvitees) {
                // DCL-566: the endpoint is scoped to the practice now, so this is
                // every pending user invitation, whoever sent it. Colleague
                // invitations carry no practice and never appear here; the
                // colleagues page reads practices#all_invitees instead.
                $scope.invitedUsers = allInvitees;
            });
        };

        $scope.usersDialog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/user_form.html',
                controller: 'UserModalController',
                resolve: {
                    practiceTypes: function () {
                        return $scope.practiceTypes;
                    },
                    practice: function () {
                        return $scope.practice;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (user) {
                var newModalInstance = $uibModal.open({
                    templateUrl: 'partials/invite_user_result.html',
                    controller: 'InviteUserResultController',
                    resolve: {
                        noLogin: function() {
                            return !!user.no_login;
                        },
                        toEmail: function() {
                            return user.email;
                        },
                        waitingForProviderSlot: function() {
                            // DCL-566: reuses the badge helper from the users list.
                            // The server returns the created invitation, so it
                            // carries status 'invited' and roles_mask; a no-login
                            // user has no status and answers false. Resolves are
                            // evaluated before the initPractice() call below, so
                            // plan_limits is still the pre-send state.
                            return $scope.waitingForProviderSlot(user);
                        }
                    }
                });
                ModalHandler.set(newModalInstance);

                // DCL-558: reload so plan_limits (and the lists) reflect the new
                // invitation or no-login user.
                $scope.initPractice();
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.editDialog = function (editUser, focusNotificationPreferences) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/edit_user_form.html',
                controller: 'EditUserModalController',
                resolve: {
                    editUser: function () {
                        return editUser;
                    },
                    practiceType: function(){
                        return $scope.practice.practice_type;
                    },
                    practiceAddresses: function(){
                        return $scope.practice.addresses;
                    },
                    nameEditable: function(){
                        return false;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            if (focusNotificationPreferences) {
                modalInstance.rendered.then(function () {
                    var preferences = document.getElementById('notificationPreferences');
                    if (preferences) {
                        preferences.scrollIntoView({block: 'center'});
                        var selectedPreference = preferences.querySelector('input[type="radio"]:checked') ||
                            preferences.querySelector('input[type="radio"]');
                        if (selectedPreference) {
                            selectedPreference.focus();
                        }
                    }
                });
            }
            modalInstance.result
                .then(function (user) {
                })
                .catch(function () {
                    // Logger.log('Modal dismissed');
                    // in case user role was changed, we need to refresh practice.users
                    $scope.initPractice();
                });
        };

        $scope.initPractice();

        // Pending invitations share this table with users (user.status is set
        // only on an invitation) and may have no name yet.
        $scope.confirmDeleteUser = function (user) {
            var name = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email;

            ConfirmDialog.open(user.status ? {
                title: 'Delete this invitation?',
                message: 'The invitation to ' + name + ' will be cancelled.',
                confirmText: 'Delete invitation'
            } : {
                title: 'Delete this user?',
                message: name + ' will be removed from your practice.',
                confirmText: 'Delete user'
            }).then(function (confirmed) {
                if (confirmed) {
                    $scope.deleteUser(user);
                }
            });
        };

        $scope.deleteUser = function (user) {
            if (user.status) {
                ProviderInvitation.delete({id: user.id}, function (success) {
                        if(success.msg){
                            Notification.error( success.msg);
                        }else{
                            $scope.initPractice();
                        }

                    },
                    function (failure) {
                        Notification.error('An error occurred during invitation removal...')
                    });

            } else {
                User.delete({id: user.id}, function (success) {
                        if(success.msg){
                            Notification.error(success.msg)
                        }else{
                            $scope.initPractice();
                        }

                    },
                    function (failure) {
                        // DCL-571: removal can be refused (last admin) with a
                        // message worth showing over the generic line.
                        Notification.error((failure.data && failure.data.message) ||
                            'An error occurred during user removal...')
                    });
            }

        };

        /**
         * Returns the effective specialty name for a doctor user, or null if not applicable/defined.
         * - If practice is not multi_specialty: returns practice.practice_type.name
         * - If practice is multi_specialty and user has specialty_type_id: looks up and returns the name
         * - Otherwise: returns null (undefined specialty)
         */
        $scope.getEffectiveSpecialtyName = function(user) {
            if (!$scope.practice || !$scope.practice.practice_type) {
                return null;
            }
            
            // Check if user is a doctor
            var isDoctor = Role.hasRoles([USER_ROLES.doctor], Role.getFromMask(user.roles_mask));
            if (!isDoctor) {
                return null;
            }
            
            var practiceType = $scope.practice.practice_type;
            
            if (practiceType.code !== 'multi_specialty') {
                // Practice has a specific type, that's the effective specialty
                return practiceType.name;
            }
            
            // Practice is multi_specialty, check user's specialty_type_id
            if (!user.specialty_type_id) {
                return null; // Not defined
            }
            
            // Look up the specialty name from practiceTypes
            var practiceTypes = $scope.practiceTypes;
            if (!practiceTypes || !practiceTypes.length) {
                return null;
            }
            
            for (var i = 0; i < practiceTypes.length; i++) {
                if (practiceTypes[i].id === user.specialty_type_id) {
                    return practiceTypes[i].name;
                }
            }
            
            return null;
        };

        $scope.roleName = function(roles_mask, user){
            var str = '';
            var effectiveSpecialty = user ? $scope.getEffectiveSpecialtyName(user) : null;

            Role.getFromMask(roles_mask).reverse().forEach(function(elem){
                var roleName = elem.name;

                // If this is the Doctor role and we have an effective specialty, append it
                if (elem.id === 'doctor' && effectiveSpecialty) {
                    roleName = elem.name + '(' + effectiveSpecialty + ')';
                }

                str += str == '' ? roleName : ', ' + roleName;
            });
            return str;
        };

        // DCL-566: a pending doctor invitation that the plan cannot absorb yet.
        // The invitation is valid and stays open — it just cannot be accepted
        // until a provider slot frees up or the practice upgrades.
        $scope.waitingForProviderSlot = function (user) {
            var providers = $scope.practice && $scope.practice.plan_limits && $scope.practice.plan_limits.providers;

            return !!(user && user.status === 'invited' &&
                (user.roles_mask & USER_ROLES.doctor.mask) !== 0 &&
                providers && providers.limit && !providers.can_add);
        };

    }]);